import React from "react";
import styled from "styled-components";

const StyledInput = styled.input`
  &&& {
    background-color: #fff;
    border: ${(props) => (props.$isvalid ? "none" : "1px solid red")};
    height: 34px;
    margin-right: 3px;
    width: 190px;
    outline: none;
  }

  &::placeholder {
    color: ${(props) => (props.$isvalid ? "#bbb" : "red")};
  }
`;

const SearchInput = ({
  type = "text",
  value,
  onChange,
  onKeyDown,
  placeholder,
  maxLength,
  width = "190px",
  style = {},
  disabled = false,
  isvalid = true,
  autoFocus = false,
  inputMode,
}) => {
  return (
    <StyledInput
      type={type}
      width={width}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      maxLength={maxLength}
      style={{ width: width, ...style }}
      disabled={disabled}
      $isvalid={isvalid}
      autoFocus={autoFocus}
      inputMode={inputMode}
    />
  );
};

export default SearchInput;
